import {
    CLASS_GOLD,
    CLASS_PREMIUM,
    CLASS_STANDARD,
    HOYTS_CINEMAS,
    READING_CINEMAS,
    VILLAGE_CINEMAS
} from "@config/config";

const experienceDescriptions = {
    GOLD: "Gold | Lux | Titan Luxe",
    STND: "Standard Seating",
    PREM: "VMAX | Premium | Xtreme | Dbox"
};

export const getExperienceDetails = (input, options = {}) => {
    const format = options.format || "short";
    const getValue = options.get || null;
    const ticketClassId = typeof input === "number" ? input : null;
    const inputStr = typeof input === "string" ? input.trim().toUpperCase() : "";
    const sessionType = (options.sessionType || "").toLowerCase();
    const groupId = Number(options.cinemaGroupId);

    const experienceMap = {
        STND: {
            short: "STND",
            long: "Standard",
            value: "STND",
            banner: "STND-banner.png",
            image: "STND.png",
            code: "STND",
            description: experienceDescriptions.STND,
            ticketClassId: CLASS_STANDARD,
        },
        PREM: {
            short: "PREM",
            long: "Premium",
            value: "PREM",
            banner: "PREM-banner.png",
            image: "PREM.png",
            code: "PREM",
            description: experienceDescriptions.PREM,
            ticketClassId: CLASS_PREMIUM,
        },
        GOLD: {
            short: "GOLD",
            long: "Gold",
            value: "GOLD",
            banner: "GOLD-banner.png",
            image: "GOLD.png",
            code: "GOLD",
            description: experienceDescriptions.GOLD,
            ticketClassId: CLASS_GOLD,

        }
    };
    
    if (experienceMap[inputStr]) {
        const match = experienceMap[inputStr];
        return getValue ? match[getValue] : match;
    }

    if (ticketClassId !== null) {
        let short = "STND";
        let long = "Standard";

        switch (ticketClassId) {
            case CLASS_GOLD:
                short = "GOLD";
                long = groupId === HOYTS_CINEMAS ? "Lux"
                    : groupId === READING_CINEMAS ? "Titan Luxe"
                        : "Gold";
                break;

            case CLASS_PREMIUM:
                short = "PREM";
                if (groupId === HOYTS_CINEMAS) {
                    const isDbox = sessionType.includes("dbox");
                    long = isDbox ? "DBox" : "Xtremescreen";
                } else if (groupId === VILLAGE_CINEMAS) {
                    long = "VMAX";
                } else {
                    long = "Premium";
                }
                break;

            case CLASS_STANDARD:
            default:
                short = "STND";
                if (groupId === VILLAGE_CINEMAS) {
                    if (sessionType.includes("vpremium")) {
                        short = "PREM";
                        long = "Vpremium";
                    } else if (sessionType.includes("vjunior")) {
                        long = "Vjunior";
                    }
                }
                break;
        }

        if (experienceMap[short]) {
            const match = experienceMap[short];
            return getValue ? match[getValue] : match;
        }
    }

    return {
        short: "unknown-0",
        long: "Unnamed",
        value: "unknown-0",
        banner: "unknown-0-banner.png",
        image: "unknown-0.png",
        code: "unknown-0",
        description: ""
    };
};



export const getAllExperiences = () => [
    {
        code: "STND",
        label: "Standard",
        image: "STND.png",
        banner: "STND-banner.png",
        path: "standard",
        description: experienceDescriptions.STND
    },
    {
        code: "PREM",
        label: "Premium",
        image: "PREM.png",
        banner: "PREM-banner.png",
        path: "premium",
        description: experienceDescriptions.PREM
    },
    {
        code: "GOLD",
        label: "Gold",
        image: "GOLD.png",
        banner: "GOLD-banner.png",
        path: "gold",
        description: experienceDescriptions.GOLD
    },
];
